/**
 * @constant
 * @type {MapOptions}
 * @default
 */
const mapOptions = {
  /**
   * Color used for the background of the Map div. This color will be visible
   * when tiles have not yet loaded as the user pans. This option can only be
   * set when the map is initialized.
   */
  backgroundColor: '#ffffff',

  /** The initial Map center. Required. */
  center: { lat: 37.983810, lng: 23.727539 },

  /**
   * When false, map icons are not clickable. A map icon represents a point of
   * interest, also known as a POI. By default map icons are clickable.
   */
  clickableIcons: true,

  /** Enables/disables all default UI. May be overridden individually. */
  disableDefaultUI: false,

  /** Enables/disables zoom and center on double click. Enabled by default. */
  disableDoubleClickZoom: false,

  /**
   * If false, prevents the map from being dragged. Dragging is enabled by
   * default.
   */
  draggable: true,

  /** The enabled/disabled state of the Fullscreen control. */
  fullscreenControl: false,

  /** The display options for the Fullscreen control. */
  fullscreenControlOptions: {
    position: 7
  },

  /**
   * This setting controls how gestures on the map are handled.
   * 'cooperative' | 'greedy' | 'none' | 'auto'
   */
  gestureHandling: 'cooperative',

  /**
   * If false, prevents the map from being controlled by the keyboard.
   * Keyboard shortcuts are enabled by default.
   */
  keyboardShortcuts: true,

  /** The initial enabled/disabled state of the Map type control. */
  mapTypeControl: false,

  /** The initial display options for the Map type control. */
  mapTypeControlOptions: {
    mapTypeIds: ['hybrid', 'roadmap', 'satellite', 'terrain'],
    position: 7,
    style: 0
  },

  /** The initial Map mapTypeId. Defaults to ROADMAP. */
  mapTypeId: 'roadmap',

  /**
   * The maximum zoom level which will be displayed on the map. If omitted, or
   * set to null, the maximum zoom from the current map type is used instead.
   * Valid values: Integers between zero, and up to the supported maximum zoom
   * level.
   */
  maxZoom: null,

  /**
   * The minimum zoom level which will be displayed on the map. If omitted, or
   * set to null, the minimum zoom from the current map type is used instead.
   * Valid values: Integers between zero, and up to the supported maximum zoom
   * level.
   */
  minZoom: null,

  /** If true, do not clear the contents of the Map div. */
  noClear: false,

  /** The enabled/disabled state of the Rotate control. */
  rotateControl: true,

  /** The display options for the Rotate control. */
  rotateControlOptions: {
    position: 1
  },

  /** The initial enabled/disabled state of the Scale control. */
  scaleControl: true,

  /** The initial display options for the Scale control. */
  scaleControlOptions: {},

  /**
   * If false, disables scrollwheel zooming on the map. The scrollwheel is
   * enabled by default.
   */
  scrollwheel: true,

  /**
   * The initial Map zoom level. Required. Valid values: Integers between
   * zero, and up to the supported maximum zoom level.
   */
  zoom: 4,

  /** The enabled/disabled state of the Zoom control. */
  zoomControl: false,

  /** The display options for the Zoom control. */
  zoomControlOptions: {
    position: 1,
    style: 0
  }
}

export default mapOptions
